import { Mail, Phone, MapPin, User, Clock } from "lucide-react";
import { COMPANY } from "@/lib/company";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      {/* Hero */}
      <section className="bg-brand-green text-white pt-20 pb-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <span className="inline-block px-4 py-1.5 bg-brand-gold text-brand-green-dark text-[11px] font-bold uppercase tracking-[0.25em] rounded-sm mb-5">Contact Us</span>
          <h1 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-tight">
            Let's Build a <span className="text-brand-gold">Sourcing Partnership</span>
          </h1>
          <p className="mt-6 text-white/85 max-w-2xl mx-auto">
            Fill out the inquiry form and our team will respond within one business day with specifications, available batches, and pricing.
          </p>
        </div>
      </section>

      {/* Contact Grid */}
      <section className="py-20 bg-brand-cream">
        <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-5 gap-10">
          {/* Info */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-lg p-6 border border-neutral-200 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-brand-green/10 flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-brand-green" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-gold font-bold">Registered Office</div>
                  <div className="mt-1 text-brand-charcoal text-sm leading-relaxed">{COMPANY.address}</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 border border-neutral-200 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-brand-green/10 flex items-center justify-center shrink-0">
                  <Mail className="w-5 h-5 text-brand-green" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-gold font-bold">Business Email</div>
                  <a data-testid="page-contact-email" href={`mailto:${COMPANY.email}`} className="mt-1 block text-brand-charcoal hover:text-brand-green font-semibold">{COMPANY.email}</a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 border border-neutral-200 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-brand-green/10 flex items-center justify-center shrink-0">
                  <Phone className="w-5 h-5 text-brand-green" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-gold font-bold">Phone / WhatsApp</div>
                  <a data-testid="page-contact-phone" href={`tel:${COMPANY.phoneRaw}`} className="mt-1 block text-brand-charcoal hover:text-brand-green font-semibold">{COMPANY.phone}</a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 border border-neutral-200 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-brand-green/10 flex items-center justify-center shrink-0">
                  <User className="w-5 h-5 text-brand-green" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-gold font-bold">Director</div>
                  <div className="mt-1 text-brand-charcoal font-semibold">{COMPANY.director}</div>
                </div>
              </div>
            </div>

            <div className="bg-brand-green text-white rounded-lg p-6 shadow-md">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-md bg-brand-gold/20 flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-brand-gold" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-brand-gold font-bold">Response Time</div>
                  <div className="mt-1 text-sm">All B2B inquiries answered within 24 business hours (IST 09:00 – 19:00).</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg p-6 border border-neutral-200 shadow-sm">
              <div className="text-xs uppercase tracking-widest text-brand-gold font-bold mb-3">Compliance</div>
              <div className="grid grid-cols-1 gap-2 text-sm text-brand-charcoal">
                <div><span className="font-semibold text-brand-green">IEC:</span> <span className="font-mono">{COMPANY.iec}</span></div>
                <div><span className="font-semibold text-brand-green">GSTIN:</span> <span className="font-mono">{COMPANY.gstin}</span></div>
                <div><span className="font-semibold text-brand-green">FSSAI:</span> <span className="font-mono">{COMPANY.fssai}</span></div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}
